/**
 * Therapists data for the team section
 * Contains professional information about each team member
 */
export const THERAPISTS = [
  {
    name: "Astrid Jung",
    qualifications: [
      "Heilpraktikerin für Psychotherapie",
      "EMDR-Therapie",
      "Systemische Therapie",
      "Hypnotherapie",
      "Traumatherapie",
      "Mediation und Konfliktklärung",
      "Paartherapie",
      "Burnout-Prävention",
    ],
    description:
      "\n" +
      "Als Heilpraktikerin für Psychotherapie verfüge ich über fundierte Ausbildungen und langjährige praktische Erfahrung in verschiedenen therapeutischen Methoden. Mein Ansatz basiert auf wissenschaftlich fundierten Verfahren, die ich individuell auf Ihre Bedürfnisse abstimme.\n" +
      "\n" +
      "Zusätzlich bringe ich verschiedene Perspektiven aus meiner langjährigen Erfahrung in der Wirtschaft und als Mediatorin mit ein. Mir ist bewusst, dass Vielseitigkeit eine wichtige Haltung in diesem Beruf ist.\n",
    image: require("@/assets/images/AstridPortrait.jpeg"),
  },
];
